import {isEmptyArray} from "@/helper/Array";
import _ from "lodash";

export function handleSingleCharacteristic (item)
{
	return {
		characteristic: item.item?.id,
		specificities: transformSpecificities(item),
		supplements: transformSupplements(item),
		experience: item.experience?.id,
		selfAssessment: item.selfAssessment?.id,
		requirement: item.requirement?.id,
		educations: _.map(item.educations || [], 'id'),
		freeText: item.freeText,
	};
}

export function transformSpecificities (item)
{
	if (!item.specificities || isEmptyArray(item.specificities))
	{
		return [];
	}

	return _.map(item.specificities, specificityItem =>
	{
		let data = {
			specificity: specificityItem.specificity.id,
		};

		if (specificityItem.specificityType)
		{
			data.specificityType = specificityItem.specificityType.id;
		}

		return data;
	});
}

export function transformSupplements (item)
{
	if (!item.supplements || isEmptyArray(item.supplements))
	{
		return [];
	}

	return _.map(item.supplements, supplementItem =>
	{
		return {
			characteristicType: supplementItem.characteristicType.id,
			items: _.map(
				supplementItem.items,
				innerItem => handleSingleCharacteristic(innerItem)
			)
		};
	});
}
